import { getApiBase, safeJson, unwrapArray } from "./http";
import type { PersonLite } from "../types";

export const fetchPeopleApi = async (): Promise<PersonLite[]> => {
    const base = getApiBase();
    const res = await fetch(`${base}/api/persons`);
    if (!res.ok) throw new Error(`Kunne ikke hente personer (${res.status})`);

    const data = await safeJson<any>(res);
    const arr = unwrapArray(data);

    const mapped: PersonLite[] = arr
        .map((p: any) => {
            const rawId =
                p.personID ??
                p.PersonID ??
                p.personId ??
                p.PersonId ??
                p.id ??
                p.ID;

            const personID = Number(rawId);

            const fullName = String(
                p.fullName ??
                p.FullName ??
                p.name ??
                p.Name ??
                [p.firstName ?? p.FirstName, p.lastName ?? p.LastName].filter(Boolean).join(" ")
            ).trim();

            return {
                personID,
                fullName: fullName || `Person #${Number.isFinite(personID) ? personID : "?"}`,
                email: p.email ?? p.Email ?? undefined,
                functionName:
                    p.functionName ?? p.FunctionName ?? p.function ?? p.Function ?? undefined,
            };
        })
        .filter((x: PersonLite) => Number.isFinite(x.personID) && x.personID > 0);

    return mapped;
};